import { motion } from 'framer-motion';

type NavItem = 'home' | 'character' | 'events' | 'quests' | 'chronicle';

interface BottomNavProps {
  active: NavItem;
  onChange: (item: NavItem) => void;
}

const NAV_ITEMS: { id: NavItem; label: string; icon: React.ReactNode }[] = [
  {
    id: 'home',
    label: 'Город',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
        <path d="M3 10.5L12 3l9 7.5v10a1 1 0 01-1 1h-5v-6h-6v6H4a1 1 0 01-1-1v-10z" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="2" />
      </svg>
    ),
  },
  {
    id: 'character',
    label: 'Мой Персонаж',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
        <circle cx="12" cy="7" r="4" strokeLinecap="round" />
        <path d="M5 21v-2a4 4 0 014-4h6a4 4 0 014 4v2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 11v3m-2 2h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'events',
    label: 'Встречи',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
        <rect x="3" y="4" width="18" height="16" rx="2" strokeLinecap="round" />
        <path d="M3 10h18M8 2v4M16 2v4" strokeLinecap="round" />
        <circle cx="12" cy="15" r="2" />
      </svg>
    ),
  },
  {
    id: 'quests',
    label: 'Квесты',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" strokeLinecap="round" strokeLinejoin="round" />
        <rect x="9" y="3" width="6" height="4" rx="1" strokeLinecap="round" />
        <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    id: 'chronicle',
    label: 'Хроника',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6">
        <path d="M4 4h12a2 2 0 012 2v14l-4-2-4 2-4-2-4 2V6a2 2 0 012-2z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 8h4M8 12h6" strokeLinecap="round" />
        <circle cx="17" cy="5" r="2" strokeWidth="1" />
      </svg>
    ),
  },
];

export function BottomNav({ active, onChange }: BottomNavProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 safe-area-bottom">
      <div className="bg-gradient-to-t from-primary-950 via-primary-950/95 to-transparent pt-4 pb-2 px-2">
        <div className="flex justify-around items-end">
          {NAV_ITEMS.map((item) => {
            const isActive = active === item.id;
            return (
              <motion.button
                key={item.id}
                whileTap={{ scale: 0.9 }}
                onClick={() => onChange(item.id)}
                className={`flex flex-col items-center gap-1 px-2 py-2 rounded-xl transition-colors ${
                  isActive
                    ? 'text-accent-warm'
                    : 'text-primary-500 hover:text-primary-300'
                }`}
              >
                <div className="relative">
                  {item.icon}
                  {isActive && (
                    <motion.div
                      layoutId="nav-glow"
                      className="absolute -inset-1 bg-accent-warm/20 rounded-full blur-sm -z-10"
                      transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                    />
                  )}
                </div>
                <span className={`text-[10px] font-medium ${isActive ? 'text-accent-warm' : ''}`}>
                  {item.label}
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
